// frontend/src/pages/Sabesp/components/Sidebar.js
import React from "react";
import WorkspaceSelector from "./WorkspaceSelector.js";

// Agrupamento por data (Hoje / Ultimos 7 dias / Mais antigas) derivado do
// timestamp salvo em cada sessao.
function groupSessions(sessions) {
  const startOfToday = new Date().setHours(0, 0, 0, 0);
  const sevenDaysAgo = Date.now() - 7 * 86400000;
  const groups = { today: [], last7: [], older: [] };
  sessions.forEach((s) => {
    const ts = s.timestamp || 0;
    if (ts >= startOfToday) groups.today.push(s);
    else if (ts >= sevenDaysAgo) groups.last7.push(s);
    else groups.older.push(s);
  });
  return groups;
}

function SessionGroup({ title, items, activeSessionId, onSelectSession, onDeleteSession }) {
  if (items.length === 0) return null;
  return (
    <>
      <div className="sabesp-sidebar-group-title">{title}</div>
      {items.map((session) => (
        <div
          key={session.id}
          className={`sabesp-chat-list-item-link${session.id === activeSessionId ? " active" : ""}`}
          onClick={() => onSelectSession(session.id)}
        >
          <span>{session.name}</span>
          <button
            className="sabesp-btn-delete-session"
            onClick={(e) => {
              e.stopPropagation();
              onDeleteSession(session.id);
            }}
          >
            &times;
          </button>
        </div>
      ))}
    </>
  );
}

export default function Sidebar({
  sessions, loading, activeSessionId, onNewChat, onSelectSession, onDeleteSession,
  groups, activeGroupId, onSelectGroup, onCreateGroup, onManageGroup,
}) {
  const { today, last7, older } = groupSessions(sessions);
  return (
    <aside className="sabesp-sidebar-card">
      <button className="sabesp-btn-new-chat" onClick={onNewChat}>
        <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
          <line x1="12" y1="5" x2="12" y2="19"></line>
          <line x1="5" y1="12" x2="19" y2="12"></line>
        </svg>
        Novo Chat
      </button>

      <WorkspaceSelector
        groups={groups}
        activeGroupId={activeGroupId}
        onSelect={onSelectGroup}
        onCreateGroup={onCreateGroup}
        onManage={onManageGroup}
      />

      <div className="sabesp-search-container">
        <input type="text" id="sabesp-search-chat" placeholder="Buscar chat" />
        <svg className="sabesp-search-icon" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
          <circle cx="11" cy="11" r="8"></circle>
          <line x1="21" y1="21" x2="16.65" y2="16.65"></line>
        </svg>
      </div>

      <div className="sabesp-chats-sidebar-list">
        {sessions.length === 0 && (
          <div className="sabesp-chat-list-item-empty">
            {loading ? (
              <>
                <span className="sabesp-spinner"></span> Carregando conversas...
              </>
            ) : (
              "Nenhum chat ativo"
            )}
          </div>
        )}
        <SessionGroup title="Hoje" items={today} activeSessionId={activeSessionId} onSelectSession={onSelectSession} onDeleteSession={onDeleteSession} />
        <SessionGroup title="Últimos 7 dias" items={last7} activeSessionId={activeSessionId} onSelectSession={onSelectSession} onDeleteSession={onDeleteSession} />
        <SessionGroup title="Mais antigas" items={older} activeSessionId={activeSessionId} onSelectSession={onSelectSession} onDeleteSession={onDeleteSession} />
      </div>
    </aside>
  );
}
